<template>
  <div>
    <v-form ref="form">
      <v-dialog
        fullscreen
        value="true"
        transition="dialog-bottom-transition"
      >
        <v-card>
          <v-app-bar flat class="card-toolbar-title">
            <v-toolbar-title>
              {{ editedItem.databaseId ? 'Edit' : 'Add' }} Client Database
            </v-toolbar-title>
            <v-spacer />
            <v-btn icon @click.native="close">
              <v-icon>close</v-icon>
            </v-btn>
          </v-app-bar>

          <v-card-text>
            <v-text-field
              id="userName"
              v-model="editedItem.userName"
              :rules="required"
              class="required"
              label="User Name"
              name="userName"
            />
            <v-text-field
              id="connectionUrl"
              v-model="editedItem.connectionUrl"
              :rules="required"
              class="required"
              label="Connection URL"
              name="connectionUrl"
            />
            <v-text-field
              id="appId"
              v-model="editedItem.appId"
              label="MRxFlow App ID"
              name="appId"
            />
            <v-text-field
              id="paUrl"
              v-model="editedItem.paUrl"
              label="PA Url"
              name="paUrl"
            />
            <v-text-field
              id="cognitoUrl"
              v-model="editedItem.cognitoUrl"
              label="Cognito Url"
              name="cognitoUrl"
            />
            <v-text-field
              id="cognitoClientId"
              v-model="editedItem.clientId"
              label="Cognito Client Id"
              name="cognitoClientId"
            />
            <v-radio-group v-show="editedItem.databaseId" v-model="secretType" label="Cognito Secret" row>
              <v-radio label="Don't Change" value="null" />
              <v-radio label="New Secret" value="new" />
            </v-radio-group>
            <v-text-field
              v-show="secretType == 'new'"
              id="secret"
              v-model="editedItem.secret"
              :label="(!editedItem.databaseId ? '' : 'New') + ' Secret'"
              name="secret"
            />
            <v-text-field
              id="cognitoScope"
              v-model="editedItem.scope"
              label="Cognito Scope"
              name="cognitoScope"
            />
            <v-text-field
              id="defaultServiceProviderId"
              v-model="editedItem.defaultServiceProviderId"
              label="Default Pharmacy (Service Provider) NPI for Trial Adjudication"
              name="defaultServiceProviderId"
              :maxlength="15"
            />
            <v-text-field
              id="accumDb"
              v-model="editedItem.accumDb"
              label="Accum Database Name"
              name="accumDb"
            />
            <v-text-field
              id="timeZone"
              v-model="editedItem.timeZone"
              label="Time Zone"
              name="timeZone"
            />
            <v-radio-group v-show="editedItem.databaseId" v-model="passwordType" label="Password" row>
              <v-radio label="Don't Change" value="null" />
              <v-radio label="Blank Password (disable database)" value="blank" />
              <v-radio label="New Password" value="new" />
            </v-radio-group>
            <v-text-field
              v-show="passwordType == 'new'"
              id="password"
              v-model="editedItem.password"
              :label="(!editedItem.databaseId ? '' : 'New') + ' Password'"
              name="password"
            />
          </v-card-text>
          <v-card-actions>
            <div class="mx-auto">
              <v-btn text color="primary" @click.native="close">Cancel</v-btn>
              <v-btn color="primary" @click.native="save">Save</v-btn>
            </div>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-form>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'client-database-table-modal',
  props: {
    editedItem: Object
  },
  data() {
    return {
      passwordType: this.editedItem.databaseId ? 'null' : 'new',
      secretType: this.editedItem.databaseId ? 'null' : 'new',
      required: [
        v => !!v || 'Required'
      ]
    }
  },
  methods: {
    ...mapActions('manageClient', ['updateClientDatabaseDetails', 'addClientDatabaseDetails']),
    save() {
      if (this.$refs.form.validate()) {
        switch (this.passwordType) {
          case 'null':
            this.editedItem.password = null
            break
          case 'blank':
            this.editedItem.password = ''
            break
          case 'new':
            break
        }
        switch (this.secretType) {
          case 'null':
            this.editedItem.secret = null
            break
          case 'new':
            break
        }
        this[this.editedItem.databaseId ? 'updateClientDatabaseDetails' : 'addClientDatabaseDetails'](this.editedItem).then(this.close, () => {})
      }
    },
    close() {
      this.$emit('close')
    }

  }
}
</script>

<style lang="scss" scoped>
  .card-title {
    background-color: $black-3;
    color: $color-primary;
  }

  .card-toolbar-title {
    background-color: $color-secondary;
  }
</style>
